/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentSucceededReceiptPayload } from './PaymentSucceededReceiptPayload';
import {
    PaymentSucceededReceiptPayloadFromJSON,
    PaymentSucceededReceiptPayloadFromJSONTyped,
    PaymentSucceededReceiptPayloadToJSON,
    PaymentSucceededReceiptPayloadToJSONTyped,
} from './PaymentSucceededReceiptPayload';

/**
 * 
 * @export
 * @interface CardDataDto
 */
export interface CardDataDto {
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentReference: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof CardDataDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentAccountReference?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardSummary?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    partialPan?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardExpiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    issuerCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    fundingSource?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardScheme?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentMethodVariant?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    authorisePspReference?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    loyaltyToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardDataDto
     */
    isRepublish: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    aid?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    tid?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    mid?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    poiid?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    acquirerId?: string;
    /**
     * 
     * @type {PaymentSucceededReceiptPayload}
     * @memberof CardDataDto
     */
    receipt?: PaymentSucceededReceiptPayload;
    /**
     * 
     * @type {Array<string>}
     * @memberof CardDataDto
     */
    formattedReceipt?: Array<string>;
}



/**
 * Check if a given object implements the CardDataDto interface.
 */
export function instanceOfCardDataDto(value: object): value is CardDataDto {
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('isRepublish' in value) || value['isRepublish'] === undefined) return false;
    return true;
}

export function CardDataDtoFromJSON(json: any): CardDataDto {
    return CardDataDtoFromJSONTyped(json, false);
}

export function CardDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentReference': json['paymentReference'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'paymentAccountReference': json['paymentAccountReference'] == null ? undefined : json['paymentAccountReference'],
        'cardSummary': json['cardSummary'] == null ? undefined : json['cardSummary'],
        'partialPan': json['partialPan'] == null ? undefined : json['partialPan'],
        'cardExpiryDate': json['cardExpiryDate'] == null ? undefined : json['cardExpiryDate'],
        'issuerCountry': json['issuerCountry'] == null ? undefined : json['issuerCountry'],
        'fundingSource': json['fundingSource'] == null ? undefined : json['fundingSource'],
        'cardScheme': json['cardScheme'] == null ? undefined : json['cardScheme'],
        'paymentMethodVariant': json['paymentMethodVariant'] == null ? undefined : json['paymentMethodVariant'],
        'authorisePspReference': json['authorisePspReference'] == null ? undefined : json['authorisePspReference'],
        'loyaltyToken': json['loyaltyToken'] == null ? undefined : json['loyaltyToken'],
        'isRepublish': json['isRepublish'],
        'aid': json['aid'] == null ? undefined : json['aid'],
        'tid': json['tid'] == null ? undefined : json['tid'],
        'mid': json['mid'] == null ? undefined : json['mid'],
        'poiid': json['poiid'] == null ? undefined : json['poiid'],
        'acquirerId': json['acquirerId'] == null ? undefined : json['acquirerId'],
        'receipt': json['receipt'] == null ? undefined : PaymentSucceededReceiptPayloadFromJSON(json['receipt']),
        'formattedReceipt': json['formattedReceipt'] == null ? undefined : json['formattedReceipt'],
    };
}

export function CardDataDtoToJSON(json: any): CardDataDto {
    return CardDataDtoToJSONTyped(json, false);
}

export function CardDataDtoToJSONTyped(value?: CardDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentReference': value['paymentReference'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'paymentAccountReference': value['paymentAccountReference'],
        'cardSummary': value['cardSummary'],
        'partialPan': value['partialPan'],
        'cardExpiryDate': value['cardExpiryDate'],
        'issuerCountry': value['issuerCountry'],
        'fundingSource': value['fundingSource'],
        'cardScheme': value['cardScheme'],
        'paymentMethodVariant': value['paymentMethodVariant'],
        'authorisePspReference': value['authorisePspReference'],
        'loyaltyToken': value['loyaltyToken'],
        'isRepublish': value['isRepublish'],
        'aid': value['aid'],
        'tid': value['tid'],
        'mid': value['mid'],
        'poiid': value['poiid'],
        'acquirerId': value['acquirerId'],
        'receipt': PaymentSucceededReceiptPayloadToJSON(value['receipt']),
        'formattedReceipt': value['formattedReceipt'],
    };
}

